import { isVideo } from '../../../../../lib/utils/mimeType';

function canPlay(mimeType: string): boolean {
  return isVideo(mimeType);
}

export default canPlay;
